import {Client, LOGIN_URL, PROJECTS, REFRESH_TOKEN, SIGNUP, USERS} from "../../service/Client";
import {
	loading,
	error,
	listUsers,
	clearCreator, logged, LOGOUT, success
} from "./usersActionsCreator";
import {TokenManager} from "../../service/TokenManager";
import {clearSession} from "../session/sessionActions";

let client = new Client();
let tokenManager = new TokenManager();

function logUser(response, dispatch) {
	let token = response.headers.authorization.replace("Bearer ", "");
	tokenManager.save(token);
	let user = response.data;
	dispatch(logged(user));
	return user;
}

export function login(email, password) {
	return dispatch => {
		loading();

		if (email && password) {
			client.post(LOGIN_URL, {body: {email, password}})
				.then(resp => {
					let user = logUser(resp, dispatch);
				})
				.catch(e => manageError(e,dispatch));
		} else {
			let token = tokenManager.get();

			if (!token || token === "") {
				dispatch(logout());
			} else {
				//Solo per la prima volta fa il refresh del token
				client
					.get(REFRESH_TOKEN)
					.then(response => {
						if (!response.data || response.data === "") {
							dispatch(logout());
						} else {
							logUser(response, dispatch)
						}
					}).catch(() => {dispatch(logout())});
			}
		}
	};
}

export function logout() {
	tokenManager.delete();
	return dispatch => {
		dispatch(clearSession());
		dispatch({
			type: LOGOUT
		});
	}

}

export function list() {
	return dispatch => {
		client.get(USERS).then(resp => {
			dispatch(listUsers(resp.data))
		}).catch( e => manageError(e,dispatch))
	}
}

export function createProject(project) {
	return dispatch => {
		client.post(PROJECTS, {body:project}).then(() =>
			client
				.get(REFRESH_TOKEN)
				.then(response => {
					if (!response.data || response.data === "") {
						dispatch(logout());
					} else {
						logUser(response, dispatch)
					}
				})
		)
			.catch( e => manageError(e,dispatch))
	}
}

export function createUser(user) {
	return dispatch => {
		client.post(SIGNUP, {body:user}).then(() =>{
			dispatch(success());
			dispatch(list());
		}).catch( e => manageError(e,dispatch))
	}
}

export function updateUserAction(user) {
	return dispatch => {
		client.update(USERS, {elem: user.id, body:user})
			.then(() => {
				dispatch(success())
				dispatch(list())
			}).catch(e => manageError(e, dispatch));
	}
}

export function updateMeAction(user) {
	return dispatch => {
		client.update(USERS, {elem: user.id, body:user})
			.then(resp => {
				dispatch(success())
				dispatch(logged(resp.data))
			}).catch(e => manageError(e, dispatch));
	}
}

export function deleteUser(uid) {
	return dispatch => client.delete(USERS, {elem:uid})
		.then(() => dispatch(list()))
		.catch(e => manageError(e, dispatch));
}

function manageError(e, dispatch) {
	dispatch(loading(false));
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		if (e.response.data) {
			dispatch(error(e.response.data.message));
		} else {
			dispatch(error("Errore di comunicazione col server"));
		}
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', e.message);
		dispatch(error(e.message));
	}
}

export function clearAction() {
	return dispatch => { dispatch(clearCreator()) }
}
